export const DEPOSIT_INTENT = 1;
export const WITHDRAWAL_INTENT = 2;
//Direct from Commercial Bank to BOT Branch
export const DIRECT_DEPOSIT_INTENT = 5;
export const DIRECT_WITHDRAWAL_INTENT = 6;
export const DENOM_COUNTED = 1;
export const CURRENCY_WITHDRAWAL_MIN_YEAR = process.env.REACT_APP_CURRENCY_WITHDRAWAL_MIN_YEAR || 2010;
export const DEFAULT_CURRENCY = 1;
export const SCC_STOCK_BALANCE_DENOM_CODE = "STKBALDENOM";
export const SCC_STOCK_BALANCE_CONSOLIDATED_CODE = "CL";
export const SCC_STOCK_BALANCE_PHYSICAL_CODE = "SCCSTKPHY";
export const CUSTODIAN_ROLE_ID = 4;
export const BOT_MANAGEMENT_ROLE_ID = 41;
export const BOT_MANAGER_CURRENCY_OPS = 63;
export const BOT_AUDITORS_ROLE_ID = 62;
export const BOT_CUSTODIANS_ROLE_ID = 22;
export const BOT_ADMIN_ROLE_ID = 21;
export const BOT_VERIFIER_ROLE_ID = 5;
export const BOT_AUTHORIZER_ROLE_ID = 6;
export const COM_INITIATOR_ROLE_ID = 1;
export const COM_SIGNATORY_ONE_ROLE_ID = 2;
export const COM_SIGNATORY_TWO_ROLE_ID = 3;
export const COM_REP_ONE_ROLE_ID = 7;
export const COM_REP_TWO_ROLE_ID = 7;
export const SCC_BALANCE_LIMIT = {
  MINIMUM: process.env.REACT_APP_MIN_SCC_LIMIT || 3000000000,
  MAXIMUM: process.env.REACT_APP_MAX_SCC_LIMIT || 50000000000,
};
export const USE_HTTPS = process.env.REACT_APP_USE_HTTPS || 'false';
export const ESB_SERVER_URL = process.env.REACT_APP_ESB_SERVER_URL || '192.168.60.125'; 
export const TEST_SERVER_URL = process.env.REACT_APP_TEST_SERVER_URL || '192.168.60.176'; 
export const FINGERPRINT_AUTH_SERVER_URL = process.env.REACT_APP_FINGERPRINT_AUTH_SERVER_URL || 'localhost:8095';
export const NGOROMSO_SERVER_URL = process.env.REACT_APP_NGOROMSO_SERVER_URL || 'localhost:8095';
export const authorizerId = 6;
export const cb_representatives = 7;
export const OTP_LENGTH = 6;
export const OTP_MAX_TRIALS = 3;
export const MFA_TYPE_OTP = "OTP";
export const MFA_TYPE_FINGERPRINT = "FINGERPRINT";
export const USER_ACTIVE_STATUS = "ACTIVE";
export const VIEW_MODE_PARTTIAL = "PARTIAL";
export const E_SIGN_MODE_ENABLED = false; //true
export const MAX_PASSWORD_AGE = 30;
export const ignoreWithdrawalOnLimitCheckIntents = process.env.REACT_APP_IGNORE_WITHDRAWALS_ON_LIMIT_CHECK_INTENTS || 1;
